import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface Props {
  icon: LucideIcon;
  title: string;
  body?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, body, action }: Props) {
  return (
    <div className="empty">
      <div className="icon">
        <Icon size={20} />
      </div>
      <div style={{ fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>{title}</div>
      {body && <div style={{ marginBottom: 12 }}>{body}</div>}
      {action}
    </div>
  );
}
